import script from "./ThemesView.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemesView.vue?vue&type=script&setup=true&lang=js"

import "./ThemesView.vue?vue&type=style&index=0&id=18b6933b&lang=scss"

const __exports__ = script;

export default __exports__